module.exports = __webpack_public_path__ + "img/orientation-horizontal.13b1d0da.svg";